import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'src/environments/urlService';
import { DefaultMetricGroup, MetricGroupDuplicate } from '../entity/DefaultMetricGroup';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { MetricCalculationService } from "../../../../kpi/service/internal/metric-calculation.service";

@Injectable({
  providedIn: 'root',
})
export class RecoveryMetricsService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'recovery/metrics';
  }

  getDefaultGroups(): Observable<DefaultMetricGroup[]> {
    return this.http.get<DefaultMetricGroup[]>(
      this.url,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      },
    ).pipe(
      tap((groups) => groups.forEach(MetricCalculationService.setSignsForDefaultGroup)),
    );
  }

  saveDefaultMetricGroup(defaultGroup: DefaultMetricGroup): Observable<DefaultMetricGroup> {
    return this.http.post<DefaultMetricGroup>(
      this.url,
      defaultGroup,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      },
    );
  }

  updateDefaultMetricGroup(defaultGroup: DefaultMetricGroup): Observable<DefaultMetricGroup> {
    return this.http.put<DefaultMetricGroup>(
      this.url,
      defaultGroup,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      },
    );
  }

  updateAllDefaultGroupsPriority(defaultGroups: DefaultMetricGroup[]): Observable<DefaultMetricGroup[]> {
    return this.http.put<DefaultMetricGroup[]>(
      `${this.url}/priority`,
      defaultGroups,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      },
    );
  }

  deleteDefaultGroup(defaultMetricGroupId: string): Observable<void> {
    return this.http.delete<void>(this.url,
      {
        params: { defaultMetricGroupId },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }

  getCustomMetricGroupDuplicates(metricGroupName: string): Observable<MetricGroupDuplicate[]> {
    return this.http.get<MetricGroupDuplicate[]>(this.url + '/group-duplicates',
      {
        params: { metricGroupName },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, false),
        withCredentials: true,
      });
  }
}
